var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackgroundStack02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 346.3 343.9",
    style: {
      enableBackground: "new 0 0 346.3 343.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#71BD94;}\r\n\t.st1{fill:#010101;}\r\n\t.st2{fill:#899389;}\r\n\t.st3{fill:#C2E7F2;}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{opacity:0.59;fill:#71BD94;}\r\n\t.st6{clip-path:url(#SVGID_00000150083881902285872470000002259906523459592066_);}\r\n\t.st7{fill:#647073;}\r\n\t.st8{fill:#D5B270;}\r\n\t.st9{fill:#C0C7CA;}\r\n\t.st10{fill:#BEC5C8;}\r\n\t.st11{fill:#EEC270;}\r\n\t.st12{fill:#EBC070;}\r\n\t.st13{fill:#CED5D8;}\r\n\t.st14{fill:#BFC5C9;}\r\n\t.st15{fill:#CBD2D5;}\r\n\t.st16{fill:#E0E6E8;}\r\n\t.st17{fill:#D2D8DB;}\r\n\t.st18{fill:#CBC1AA;}\r\n\t.st19{fill:#657374;}\r\n\t.st20{fill:#12B693;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M280.1,94.6H135.6c-23.9,0-43.4,19.5-43.4,43.4v144.6c0,23.9,19.5,43.4,43.4,43.4h144.6 c23.9,0,43.4-19.5,43.4-43.4V138C323.5,114.1,304.1,94.6,280.1,94.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M280.1,316.3H135.6c-18.6,0-33.7-15.1-33.7-33.7v-26.2l57.1-57.1c11.1-11,29-11,40.1,0l105.9,105.9 C298.8,311.9,290,316.3,280.1,316.3L280.1,316.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M313.9,282.5c0,5.2-1.3,10.1-3.4,14.6L205.8,192.5c-14.8-14.8-38.9-14.8-53.7,0l-50.2,50.2V138 c0-18.6,15.1-33.7,33.7-33.7h144.6c18.6,0,33.7,15.1,33.7,33.7V282.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 251.2,
    cy: 157.2,
    r: 24.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 251.2,
    cy: 157.2,
    r: 14.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M218,247H49c-14.8,0-26.8-12-26.8-26.8v-169c0-14.8,12-26.8,26.8-26.8h169c14.8,0,26.8,12,26.8,26.8v169 C244.8,235,232.8,247,218,247z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.5,251.7H53.6c-19.9,0-36-16.2-36-36V55.8c0-19.9,16.2-36,36-36h159.8c19.9,0,36,16.2,36,36v159.8 C249.5,235.5,233.3,251.7,213.5,251.7z M53.6,29.2c-14.7,0-26.7,12-26.7,26.7v159.8c0,14.7,12,26.7,26.7,26.7h159.8 c14.7,0,26.7-12,26.7-26.7V55.8c0-14.7-12-26.7-26.7-26.7H53.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundStack02);
export default __webpack_public_path__ + "static/media/background_stack-02.fef5e65407c15193d21132dcd3d5427a.svg";
export { ForwardRef as ReactComponent };